import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { FC } from 'react';
import useViewModel from './viewmodel';

interface GcpPasswordInputProps {
  name: string;
  label: string;
  value: string;
  required?: boolean;
  onBlur: () => void;
  onChange: () => void;
}

const GcpPasswordInput: FC<GcpPasswordInputProps> = (props) => {
  const { name, value, label, onBlur, onChange, required } = props;
  const { on, handleClickShowPassword, handleMouseDownPassword } =
    useViewModel();

  return (
    <TextField
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              edge="end"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {on ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      label={label}
      name={name}
      required={required}
      type={on ? 'text' : 'password'}
      value={value}
      variant="outlined"
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};

export default GcpPasswordInput;
